var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "box-card",
        },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: {
                "label-width": "140px",
                "label-position": "top",
                model: _vm.pram,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("znxmc"),
                            prop: "remark",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qsrznxmc"),
                                trigger: ["blur"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isCreate == 1,
                              placeholder: _vm.$t("qsrznxmc"),
                            },
                            model: {
                              value: _vm.pram.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "remark", $$v)
                              },
                              expression: "pram.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11, offset: 1 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("isShowText"),
                            prop: "status",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.isCreate == 1,
                                placeholder: _vm.$t("qxz"),
                              },
                              model: {
                                value: _vm.pram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "status", $$v)
                                },
                                expression: "pram.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("xsan"), value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: _vm.$t("ycan"), value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("jszzh"),
                    prop: "uid_list",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qsrjszzh"),
                        trigger: ["blur"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isCreate == 1,
                        multiple: "",
                        placeholder: _vm.$t("qsrjszzh"),
                      },
                      model: {
                        value: _vm.pram.uid_list,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "uid_list", $$v)
                        },
                        expression: "pram.uid_list",
                      },
                    },
                    _vm._l(_vm.userList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.uid, value: item.uid },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("faTime"),
                            prop: "start_time",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qxzfaTime"),
                                trigger: ["change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isCreate == 1,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd hh:mm:ss",
                              format: "yyyy-MM-dd hh:mm:ss",
                              placeholder: _vm.$t("xzfaTime"),
                            },
                            model: {
                              value: _vm.pram.start_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "start_time", $$v)
                              },
                              expression: "pram.start_time",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11, offset: 1 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("endTime"),
                            prop: "end_time",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qxzendTime"),
                                trigger: ["change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isCreate == 1,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd hh:mm:ss",
                              format: "yyyy-MM-dd hh:mm:ss",
                              placeholder: _vm.$t("qxzendTime"),
                            },
                            model: {
                              value: _vm.pram.end_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "end_time", $$v)
                              },
                              expression: "pram.end_time",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("jjnr"),
                    prop: "value",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qsrjjnr"),
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _vm.isCreate == 0
                    ? _c("Tinymce", {
                        model: {
                          value: _vm.pram.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "value", $$v)
                          },
                          expression: "pram.value",
                        },
                      })
                    : _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.pram.value) },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _vm.isCreate == 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("trueText")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCreate == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.closePage()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("guanbi")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }